import { useSteps as Nt, Box as E, Stepper as Vt, Icon as ue, Flex as D, Text as J, Link as G, Button as wt, Image as Yt, IconButton as zt, theme as Ue, DrawerContent as Gt, DrawerOverlay as Ut, Drawer as Zt, DrawerHeader as Kt, DrawerBody as Xt, VStack as Jt, Skeleton as Ve, HStack as ft, SkeletonCircle as De, Grid as qt, GridItem as Qt } from "@everlywell/ui-kit";
import qe, { useEffect as U, forwardRef as yt, useState as B, useCallback as Ct, useRef as en } from "react";
import { Text as tn, useBreakpointValue as Qe, Box as nn, InputGroup as rn, Input as ln, InputRightElement as an, Icon as on } from "@chakra-ui/react";
import { CaretRight as pt, CaretLeft as sn, X as un, MagnifyingGlass as jt, List as cn, Basket as dn, User as ht, QrCode as fn } from "@phosphor-icons/react";
import { motion as et, AnimatePresence as pn } from "framer-motion";
var Ze = { exports: {} }, ye = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vt;
function hn() {
  if (vt) return ye;
  vt = 1;
  var l = qe, o = Symbol.for("react.element"), p = Symbol.for("react.fragment"), d = Object.prototype.hasOwnProperty, w = l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, v = { key: !0, ref: !0, __self: !0, __source: !0 };
  function b(R, c, C) {
    var u, y = {}, g = null, s = null;
    C !== void 0 && (g = "" + C), c.key !== void 0 && (g = "" + c.key), c.ref !== void 0 && (s = c.ref);
    for (u in c) d.call(c, u) && !v.hasOwnProperty(u) && (y[u] = c[u]);
    if (R && R.defaultProps) for (u in c = R.defaultProps, c) y[u] === void 0 && (y[u] = c[u]);
    return { $$typeof: o, type: R, key: g, ref: s, props: y, _owner: w.current };
  }
  return ye.Fragment = p, ye.jsx = b, ye.jsxs = b, ye;
}
var Ce = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gt;
function vn() {
  return gt || (gt = 1, process.env.NODE_ENV !== "production" && function() {
    var l = qe, o = Symbol.for("react.element"), p = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), w = Symbol.for("react.strict_mode"), v = Symbol.for("react.profiler"), b = Symbol.for("react.provider"), R = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), C = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), y = Symbol.for("react.memo"), g = Symbol.for("react.lazy"), s = Symbol.for("react.offscreen"), _ = Symbol.iterator, W = "@@iterator";
    function V(e) {
      if (e === null || typeof e != "object")
        return null;
      var n = _ && e[_] || e[W];
      return typeof n == "function" ? n : null;
    }
    var M = l.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(e) {
      {
        for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
          r[i - 1] = arguments[i];
        de("error", e, r);
      }
    }
    function de(e, n, r) {
      {
        var i = M.ReactDebugCurrentFrame, x = i.getStackAddendum();
        x !== "" && (n += "%s", r = r.concat([x]));
        var m = r.map(function(h) {
          return String(h);
        });
        m.unshift("Warning: " + n), Function.prototype.apply.call(console[e], console, m);
      }
    }
    var fe = !1, pe = !1, q = !1, Z = !1, L = !1, j;
    j = Symbol.for("react.module.reference");
    function A(e) {
      return !!(typeof e == "string" || typeof e == "function" || e === d || e === v || L || e === w || e === C || e === u || Z || e === s || fe || pe || q || typeof e == "object" && e !== null && (e.$$typeof === g || e.$$typeof === y || e.$$typeof === b || e.$$typeof === R || e.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      e.$$typeof === j || e.getModuleId !== void 0));
    }
    function je(e, n, r) {
      var i = e.displayName;
      if (i)
        return i;
      var x = n.displayName || n.name || "";
      return x !== "" ? r + "(" + x + ")" : r;
    }
    function he(e) {
      return e.displayName || "Context";
    }
    function $(e) {
      if (e == null)
        return null;
      if (typeof e.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof e == "function")
        return e.displayName || e.name || null;
      if (typeof e == "string")
        return e;
      switch (e) {
        case d:
          return "Fragment";
        case p:
          return "Portal";
        case v:
          return "Profiler";
        case w:
          return "StrictMode";
        case C:
          return "Suspense";
        case u:
          return "SuspenseList";
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case R:
            var n = e;
            return he(n) + ".Consumer";
          case b:
            var r = e;
            return he(r._context) + ".Provider";
          case c:
            return je(e, e.render, "ForwardRef");
          case y:
            var i = e.displayName || null;
            return i !== null ? i : $(e.type) || "Memo";
          case g: {
            var x = e, m = x._payload, h = x._init;
            try {
              return $(h(m));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var Y = Object.assign, z = 0, Ee, Re, _e, te, Se, ve, ne;
    function Te() {
    }
    Te.__reactDisabledLog = !0;
    function Pe() {
      {
        if (z === 0) {
          Ee = console.log, Re = console.info, _e = console.warn, te = console.error, Se = console.group, ve = console.groupCollapsed, ne = console.groupEnd;
          var e = {
            configurable: !0,
            enumerable: !0,
            value: Te,
            writable: !0
          };
          Object.defineProperties(console, {
            info: e,
            log: e,
            warn: e,
            error: e,
            group: e,
            groupCollapsed: e,
            groupEnd: e
          });
        }
        z++;
      }
    }
    function re() {
      {
        if (z--, z === 0) {
          var e = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: Y({}, e, {
              value: Ee
            }),
            info: Y({}, e, {
              value: Re
            }),
            warn: Y({}, e, {
              value: _e
            }),
            error: Y({}, e, {
              value: te
            }),
            group: Y({}, e, {
              value: Se
            }),
            groupCollapsed: Y({}, e, {
              value: ve
            }),
            groupEnd: Y({}, e, {
              value: ne
            })
          });
        }
        z < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var N = M.ReactCurrentDispatcher, ge;
    function le(e, n, r) {
      {
        if (ge === void 0)
          try {
            throw Error();
          } catch (x) {
            var i = x.stack.trim().match(/\n( *(at )?)/);
            ge = i && i[1] || "";
          }
        return `
` + ge + e;
      }
    }
    var xe = !1, ae;
    {
      var Le = typeof WeakMap == "function" ? WeakMap : Map;
      ae = new Le();
    }
    function ke(e, n) {
      if (!e || xe)
        return "";
      {
        var r = ae.get(e);
        if (r !== void 0)
          return r;
      }
      var i;
      xe = !0;
      var x = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var m;
      m = N.current, N.current = null, Pe();
      try {
        if (n) {
          var h = function() {
            throw Error();
          };
          if (Object.defineProperty(h.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(h, []);
            } catch (H) {
              i = H;
            }
            Reflect.construct(e, [], h);
          } else {
            try {
              h.call();
            } catch (H) {
              i = H;
            }
            e.call(h.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (H) {
            i = H;
          }
          e();
        }
      } catch (H) {
        if (H && i && typeof H.stack == "string") {
          for (var f = H.stack.split(`
`), P = i.stack.split(`
`), T = f.length - 1, k = P.length - 1; T >= 1 && k >= 0 && f[T] !== P[k]; )
            k--;
          for (; T >= 1 && k >= 0; T--, k--)
            if (f[T] !== P[k]) {
              if (T !== 1 || k !== 1)
                do
                  if (T--, k--, k < 0 || f[T] !== P[k]) {
                    var F = `
` + f[T].replace(" at new ", " at ");
                    return e.displayName && F.includes("<anonymous>") && (F = F.replace("<anonymous>", e.displayName)), typeof e == "function" && ae.set(e, F), F;
                  }
                while (T >= 1 && k >= 0);
              break;
            }
        }
      } finally {
        xe = !1, N.current = m, re(), Error.prepareStackTrace = x;
      }
      var se = e ? e.displayName || e.name : "", ee = se ? le(se) : "";
      return typeof e == "function" && ae.set(e, ee), ee;
    }
    function Ae(e, n, r) {
      return ke(e, !1);
    }
    function He(e) {
      var n = e.prototype;
      return !!(n && n.isReactComponent);
    }
    function ie(e, n, r) {
      if (e == null)
        return "";
      if (typeof e == "function")
        return ke(e, He(e));
      if (typeof e == "string")
        return le(e);
      switch (e) {
        case C:
          return le("Suspense");
        case u:
          return le("SuspenseList");
      }
      if (typeof e == "object")
        switch (e.$$typeof) {
          case c:
            return Ae(e.render);
          case y:
            return ie(e.type, n, r);
          case g: {
            var i = e, x = i._payload, m = i._init;
            try {
              return ie(m(x), n, r);
            } catch {
            }
          }
        }
      return "";
    }
    var K = Object.prototype.hasOwnProperty, be = {}, me = M.ReactDebugCurrentFrame;
    function a(e) {
      if (e) {
        var n = e._owner, r = ie(e.type, e._source, n ? n.type : null);
        me.setExtraStackFrame(r);
      } else
        me.setExtraStackFrame(null);
    }
    function I(e, n, r, i, x) {
      {
        var m = Function.call.bind(K);
        for (var h in e)
          if (m(e, h)) {
            var f = void 0;
            try {
              if (typeof e[h] != "function") {
                var P = Error((i || "React class") + ": " + r + " type `" + h + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof e[h] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw P.name = "Invariant Violation", P;
              }
              f = e[h](n, h, i, r, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (T) {
              f = T;
            }
            f && !(f instanceof Error) && (a(x), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", i || "React class", r, h, typeof f), a(null)), f instanceof Error && !(f.message in be) && (be[f.message] = !0, a(x), S("Failed %s type: %s", r, f.message), a(null));
          }
      }
    }
    var X = Array.isArray;
    function O(e) {
      return X(e);
    }
    function $e(e) {
      {
        var n = typeof Symbol == "function" && Symbol.toStringTag, r = n && e[Symbol.toStringTag] || e.constructor.name || "Object";
        return r;
      }
    }
    function Q(e) {
      try {
        return tt(e), !1;
      } catch {
        return !0;
      }
    }
    function tt(e) {
      return "" + e;
    }
    function nt(e) {
      if (Q(e))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $e(e)), tt(e);
    }
    var we = M.ReactCurrentOwner, Et = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, rt, lt, Me;
    Me = {};
    function Rt(e) {
      if (K.call(e, "ref")) {
        var n = Object.getOwnPropertyDescriptor(e, "ref").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.ref !== void 0;
    }
    function _t(e) {
      if (K.call(e, "key")) {
        var n = Object.getOwnPropertyDescriptor(e, "key").get;
        if (n && n.isReactWarning)
          return !1;
      }
      return e.key !== void 0;
    }
    function St(e, n) {
      if (typeof e.ref == "string" && we.current && n && we.current.stateNode !== n) {
        var r = $(we.current.type);
        Me[r] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', $(we.current.type), e.ref), Me[r] = !0);
      }
    }
    function Tt(e, n) {
      {
        var r = function() {
          rt || (rt = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        r.isReactWarning = !0, Object.defineProperty(e, "key", {
          get: r,
          configurable: !0
        });
      }
    }
    function kt(e, n) {
      {
        var r = function() {
          lt || (lt = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", n));
        };
        r.isReactWarning = !0, Object.defineProperty(e, "ref", {
          get: r,
          configurable: !0
        });
      }
    }
    var Dt = function(e, n, r, i, x, m, h) {
      var f = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: o,
        // Built-in properties that belong on the element
        type: e,
        key: n,
        ref: r,
        props: h,
        // Record the component responsible for creating this element.
        _owner: m
      };
      return f._store = {}, Object.defineProperty(f._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(f, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: i
      }), Object.defineProperty(f, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: x
      }), Object.freeze && (Object.freeze(f.props), Object.freeze(f)), f;
    };
    function It(e, n, r, i, x) {
      {
        var m, h = {}, f = null, P = null;
        r !== void 0 && (nt(r), f = "" + r), _t(n) && (nt(n.key), f = "" + n.key), Rt(n) && (P = n.ref, St(n, x));
        for (m in n)
          K.call(n, m) && !Et.hasOwnProperty(m) && (h[m] = n[m]);
        if (e && e.defaultProps) {
          var T = e.defaultProps;
          for (m in T)
            h[m] === void 0 && (h[m] = T[m]);
        }
        if (f || P) {
          var k = typeof e == "function" ? e.displayName || e.name || "Unknown" : e;
          f && Tt(h, k), P && kt(h, k);
        }
        return Dt(e, f, P, x, i, we.current, h);
      }
    }
    var Fe = M.ReactCurrentOwner, at = M.ReactDebugCurrentFrame;
    function oe(e) {
      if (e) {
        var n = e._owner, r = ie(e.type, e._source, n ? n.type : null);
        at.setExtraStackFrame(r);
      } else
        at.setExtraStackFrame(null);
    }
    var We;
    We = !1;
    function Be(e) {
      return typeof e == "object" && e !== null && e.$$typeof === o;
    }
    function it() {
      {
        if (Fe.current) {
          var e = $(Fe.current.type);
          if (e)
            return `

Check the render method of \`` + e + "`.";
        }
        return "";
      }
    }
    function Ot(e) {
      return "";
    }
    var ot = {};
    function Pt(e) {
      {
        var n = it();
        if (!n) {
          var r = typeof e == "string" ? e : e.displayName || e.name;
          r && (n = `

Check the top-level render call using <` + r + ">.");
        }
        return n;
      }
    }
    function st(e, n) {
      {
        if (!e._store || e._store.validated || e.key != null)
          return;
        e._store.validated = !0;
        var r = Pt(n);
        if (ot[r])
          return;
        ot[r] = !0;
        var i = "";
        e && e._owner && e._owner !== Fe.current && (i = " It was passed a child from " + $(e._owner.type) + "."), oe(e), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', r, i), oe(null);
      }
    }
    function ut(e, n) {
      {
        if (typeof e != "object")
          return;
        if (O(e))
          for (var r = 0; r < e.length; r++) {
            var i = e[r];
            Be(i) && st(i, n);
          }
        else if (Be(e))
          e._store && (e._store.validated = !0);
        else if (e) {
          var x = V(e);
          if (typeof x == "function" && x !== e.entries)
            for (var m = x.call(e), h; !(h = m.next()).done; )
              Be(h.value) && st(h.value, n);
        }
      }
    }
    function Lt(e) {
      {
        var n = e.type;
        if (n == null || typeof n == "string")
          return;
        var r;
        if (typeof n == "function")
          r = n.propTypes;
        else if (typeof n == "object" && (n.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        n.$$typeof === y))
          r = n.propTypes;
        else
          return;
        if (r) {
          var i = $(n);
          I(r, e.props, "prop", i, e);
        } else if (n.PropTypes !== void 0 && !We) {
          We = !0;
          var x = $(n);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", x || "Unknown");
        }
        typeof n.getDefaultProps == "function" && !n.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function At(e) {
      {
        for (var n = Object.keys(e.props), r = 0; r < n.length; r++) {
          var i = n[r];
          if (i !== "children" && i !== "key") {
            oe(e), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", i), oe(null);
            break;
          }
        }
        e.ref !== null && (oe(e), S("Invalid attribute `ref` supplied to `React.Fragment`."), oe(null));
      }
    }
    var ct = {};
    function dt(e, n, r, i, x, m) {
      {
        var h = A(e);
        if (!h) {
          var f = "";
          (e === void 0 || typeof e == "object" && e !== null && Object.keys(e).length === 0) && (f += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var P = Ot();
          P ? f += P : f += it();
          var T;
          e === null ? T = "null" : O(e) ? T = "array" : e !== void 0 && e.$$typeof === o ? (T = "<" + ($(e.type) || "Unknown") + " />", f = " Did you accidentally export a JSX literal instead of a component?") : T = typeof e, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", T, f);
        }
        var k = It(e, n, r, x, m);
        if (k == null)
          return k;
        if (h) {
          var F = n.children;
          if (F !== void 0)
            if (i)
              if (O(F)) {
                for (var se = 0; se < F.length; se++)
                  ut(F[se], e);
                Object.freeze && Object.freeze(F);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              ut(F, e);
        }
        if (K.call(n, "key")) {
          var ee = $(e), H = Object.keys(n).filter(function(Bt) {
            return Bt !== "key";
          }), Ne = H.length > 0 ? "{key: someKey, " + H.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!ct[ee + Ne]) {
            var Wt = H.length > 0 ? "{" + H.join(": ..., ") + ": ...}" : "{}";
            S(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, Ne, ee, Wt, ee), ct[ee + Ne] = !0;
          }
        }
        return e === d ? At(k) : Lt(k), k;
      }
    }
    function Ht(e, n, r) {
      return dt(e, n, r, !0);
    }
    function $t(e, n, r) {
      return dt(e, n, r, !1);
    }
    var Mt = $t, Ft = Ht;
    Ce.Fragment = d, Ce.jsx = Mt, Ce.jsxs = Ft;
  }()), Ce;
}
process.env.NODE_ENV === "production" ? Ze.exports = hn() : Ze.exports = vn();
var t = Ze.exports;
const Ye = 60, xt = 6, gn = (l) => {
  const {
    activeStepIndex: o,
    hideIndicators: p = !1,
    steps: d,
    stepperTheme: w = {
      light: "eggplant.light",
      base: "eggplant.base"
    }
  } = l, { activeStep: v, setActiveStep: b } = Nt({
    index: o,
    count: d.length
  });
  return U(() => {
    b(o);
  }, [o, b]), /* @__PURE__ */ t.jsx(
    E,
    { position: "relative", width: "100%", "data-testid": "stepper", children: /* @__PURE__ */ t.jsx(
      Vt,
      {
        role: "progressbar",
        index: v,
        width: "100%",
        display: "flex",
        flexWrap: "nowrap",
        children: d.map((R, c) => {
          const C = v === c, u = c === 0, y = c === d.length - 1, g = v > c;
          let s = `${Ye}px`;
          const _ = `calc(100% - ((${Ye * (d.length - 1)}px) - (${d.length - 1} * ${xt * 2}px)))`;
          return C ? s = _ : (u || y) && (s = `${Ye - xt}px`), /* @__PURE__ */ t.jsx(
            E,
            {
              width: s,
              opacity: g || C ? 1 : 0.2,
              paddingRight: y ? "0" : "6px",
              paddingLeft: u ? "0" : "6px",
              transition: "width 0.4s ease-in-out, opacity 0.4s ease-in-out",
              children: /* @__PURE__ */ t.jsx(
                E,
                {
                  paddingTop: p ? 2 : 5,
                  position: "relative",
                  width: "100%",
                  children: /* @__PURE__ */ t.jsx(
                    E,
                    {
                      width: "100%",
                      position: "absolute",
                      top: "0",
                      backgroundColor: g ? w.light : w.base,
                      height: p ? "4px" : "8px",
                      borderRadius: "4",
                      left: "0"
                    }
                  )
                }
              )
            },
            `step-${c}`
          );
        })
      }
    ) }
  );
}, On = qe.memo(gn), Pn = ({
  children: l,
  ...o
}) => /* @__PURE__ */ t.jsx(
  tn,
  { color: "tints.uiGrey", fontSize: ["md", null, null, "lg"], ...o, children: l }
), Oe = (l, o) => {
  const p = (l == null ? void 0 : l.startsWith("http")) || (l == null ? void 0 : l.startsWith("mailto"));
  return o && !p ? {
    to: l
  } : {
    href: l
  };
}, ze = yt(
  (l, o) => {
    const {
      label: p,
      additionalContent: d,
      mainTextFontSize: w,
      linkComponent: v,
      href: b,
      ...R
    } = l, c = v || G, C = Oe(b, !!v);
    return /* @__PURE__ */ t.jsxs(
      E,
      {
        ref: o,
        as: c,
        display: "flex",
        alignItems: "center",
        gap: [null, null, null, 1],
        justifyContent: [null, null, null, "space-between"],
        paddingY: [3, null, null, 0],
        color: "tints.black",
        _hover: { color: "viridian.base", textDecoration: "none" },
        borderBottom: ["1px", null, null, "unset"],
        borderColor: ["tints.cream", null, null, "unset"],
        width: ["100%", null, null, "fit-content"],
        cursor: "pointer",
        ...C,
        ...R,
        children: [
          /* @__PURE__ */ t.jsx(
            ue,
            {
              display: ["none", null, null, "block"],
              as: pt,
              fontSize: "lg",
              color: "viridian.light",
              role: "img",
              "aria-label": "Caret right icon",
              weight: "bold"
            }
          ),
          /* @__PURE__ */ t.jsxs(
            D,
            { alignItems: "center", gap: "1", width: ["100%", null, null, "auto"], children: [
              /* @__PURE__ */ t.jsx(
                J,
                {
                  fontSize: [w || "xl", null, null, "lg"],
                  fontWeight: "medium",
                  children: p
                }
              ),
              d && (typeof d == "string" ? /* @__PURE__ */ t.jsx(
                J,
                {
                  fontSize: ["xl", null, null, "lg"],
                  fontWeight: "medium",
                  color: "tints.uiGrey",
                  sx: {
                    "a:hover &": {
                      color: "viridian.base"
                    }
                  },
                  children: d
                }
              ) : d),
              /* @__PURE__ */ t.jsx(
                ue,
                {
                  display: ["block", null, null, "none"],
                  as: pt,
                  fontSize: "2xl",
                  color: "tints.uiGrey",
                  role: "img",
                  "aria-label": "Caret right icon",
                  marginLeft: "auto"
                }
              )
            ] }
          )
        ]
      }
    );
  }
), Ie = yt(
  (l, o) => {
    const { children: p, isSelected: d, ...w } = l, v = l.backgroundColor || (d ? "tints.lightCream" : "transparent");
    return /* @__PURE__ */ t.jsx(
      wt,
      {
        ref: o,
        borderRadius: "full",
        backgroundColor: v,
        fontSize: "lg !important",
        fontWeight: "normal",
        color: "tints.black",
        sx: {
          "&[href]": {
            textDecoration: "none"
          }
        },
        _before: {
          content: '""',
          position: "absolute",
          top: [null, null, null, -6],
          right: [null, null, null, -2],
          bottom: [null, null, null, -6],
          left: [null, null, null, -2]
        },
        _hover: {
          backgroundColor: v,
          textDecoration: "none",
          filter: "brightness(0.95)"
        },
        ...w,
        children: p
      }
    );
  }
), xn = ({
  title: l,
  description: o,
  imageSrc: p,
  imageElement: d,
  button: w,
  backgroundColor: v = "viridian.wash",
  onClick: b,
  href: R,
  linkComponent: c
}) => {
  const g = c || G, s = Oe(R, !!c), _ = Qe({
    base: !1,
    tablet: !1,
    largeTablet: !1,
    desktop: !0
  });
  return /* @__PURE__ */ t.jsxs(
    D,
    {
      direction: ["row", null, null, "column"],
      alignItems: ["center"],
      borderRadius: "xl",
      overflow: "hidden",
      height: ["80px", null, null, "272px"],
      backgroundColor: v,
      onClick: b,
      "data-testid": "spotlight-card",
      position: "relative",
      transition: "box-shadow 0.2s ease-in-out",
      border: "1px solid",
      borderColor: "transparent",
      minWidth: ["100%", null, null, "320px"],
      maxWidth: ["100%", null, null, "380px"],
      _hover: {
        boxShadow: "lg",
        textDecoration: "none",
        border: "1px solid",
        borderColor: "tints.white"
      },
      as: _ ? D : g,
      ..._ ? {} : s,
      children: [
        /* @__PURE__ */ t.jsx(
          E,
          {
            width: ["72px", null, null, "100%"],
            height: ["100%", null, null, "188px"],
            sx: {
              img: {
                height: _ ? "188px" : "100%"
              }
            },
            children: p ? /* @__PURE__ */ t.jsx(
              Yt,
              {
                src: p,
                objectFit: "cover",
                width: "100%",
                alt: "",
                "data-testid": "spotlight-card-image"
              }
            ) : /* @__PURE__ */ t.jsx(
              E,
              {
                height: [80, null, null, 188],
                overflow: "hidden",
                children: d
              }
            )
          }
        ),
        /* @__PURE__ */ t.jsxs(
          D,
          {
            direction: ["column", null, null, "row"],
            justifyContent: [null, null, null, "space-between"],
            alignItems: ["left", null, null, "center"],
            padding: "4",
            height: [
              "80px",
              null,
              null,
              "84px"
            ],
            width: "100%",
            bottom: [null, null, null, "0"],
            backgroundColor: [null, null, null, `${v}CC`],
            backdropFilter: [null, null, null, "blur(8px)"],
            flex: "1",
            gap: [null, null, null, 3],
            children: [
              /* @__PURE__ */ t.jsxs(
                D,
                { direction: "column", justifyContent: "center", height: "100%", children: [
                  /* @__PURE__ */ t.jsx(
                    J,
                    { fontSize: "lg", fontWeight: "medium", color: "tints.black", children: l }
                  ),
                  /* @__PURE__ */ t.jsx(
                    J,
                    { fontSize: "sm", color: "tints.darkGrey", children: o }
                  )
                ] }
              ),
              _ ? /* @__PURE__ */ t.jsx(E, { children: w }) : null
            ]
          }
        )
      ]
    }
  );
}, ce = (l) => /* @__PURE__ */ t.jsx(
  zt,
  {
    size: "sm",
    width: ["40px", null, null, "46px"],
    height: ["40px", null, null, "46px"],
    padding: ["2 !important", null, null, "3 !important"],
    colorScheme: "whiteCS",
    backgroundColor: "tints.cream",
    sx: {
      svg: {
        width: "24px",
        height: "24px"
      }
    },
    _hover: {
      backgroundColor: "tints.cream",
      filter: "brightness(0.95)"
    },
    ...l
  }
), bn = ({
  color: l = Ue.colors.viridian.base,
  width: o
}) => /* @__PURE__ */ t.jsx(
  nn,
  {
    as: "svg",
    width: o,
    height: "auto",
    viewBox: "0 0 116 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "Everlywell Logo",
    children: /* @__PURE__ */ t.jsx(
      "g",
      { id: "Everlywell Logo", children: /* @__PURE__ */ t.jsx(
        "path",
        {
          fill: l,
          id: "Everlywell Logo_2",
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M54.8224 1V17.8352H52.4272V1H54.8224ZM5.65731 14.992C4.9835 14.4474 4.59261 13.726 4.48231 12.8278H13.7822C13.9984 10.4829 13.5723 8.70006 12.5039 7.47915C11.4322 6.25824 9.93769 5.64945 8.01698 5.64945C6.23518 5.64945 4.78896 6.22479 3.67214 7.38216C2.55841 8.5395 2 9.92767 2 11.8377C2 13.7476 2.56171 15.273 3.68501 16.4136C4.80831 17.5542 6.30612 18.1229 8.18163 18.1229C9.11125 18.1229 10.0216 17.9489 10.9125 17.5944C11.8034 17.2431 12.533 16.7447 13.1075 16.1025L11.5517 14.5371C11.2095 14.9217 10.7253 15.2294 10.099 15.4636C9.46959 15.6944 8.84662 15.8115 8.22684 15.8115C7.18735 15.8115 6.33197 15.5372 5.65731 14.992ZM10.4671 8.60977C11.0772 9.10817 11.416 9.81395 11.4774 10.7305H4.52751C4.71152 9.81395 5.12475 9.10817 5.77027 8.60977C6.41589 8.11136 7.18735 7.86384 8.08473 7.86384C9.05966 7.86384 9.85696 8.11136 10.4671 8.60977ZM22.1465 17.8819L27.0047 5.93699H24.3771L22.6565 10.2486L20.8424 15.2828L18.8217 9.76697L17.2884 5.93699H14.6382L19.5189 17.8819H22.1465ZM30.3737 12.8244C30.4835 13.7242 30.8741 14.4467 31.5487 14.992C32.2234 15.5372 33.0788 15.8115 34.1181 15.8115C34.7379 15.8115 35.361 15.6944 35.9905 15.4636C36.6166 15.2294 37.1009 14.9217 37.4431 14.5371L38.999 16.1025C38.4244 16.7447 37.6948 17.2431 36.8039 17.5944C35.9129 17.9489 35.0027 18.1229 34.0729 18.1229C32.1975 18.1229 30.6997 17.5542 29.5764 16.4136C28.453 15.273 27.8914 13.7476 27.8914 11.8377C27.8914 9.92767 28.4498 8.5395 29.5635 7.38216C30.6804 6.22479 32.1265 5.64945 33.9084 5.64945C35.829 5.64945 37.3236 6.25824 38.3952 7.47915C39.4638 8.70006 39.8899 10.4829 39.6736 12.8278H30.3769L30.3737 12.8244ZM37.3688 10.7305C37.3075 9.81395 36.9685 9.10817 36.3584 8.60977C35.7483 8.11136 34.951 7.86384 33.9762 7.86384C33.0788 7.86384 32.3073 8.11136 31.6617 8.60977C31.0161 9.10817 30.6029 9.81395 30.4189 10.7305H37.3688ZM44.5032 7.5263L44.3418 5.96085H44.3385H42.108V17.8355H44.5032V11.4031C44.5032 10.3595 44.8001 9.5567 45.3877 8.99473C45.9751 8.43278 46.7112 8.15181 47.5956 8.15181C48.3703 8.15181 49.0417 8.39264 49.6163 8.87432L50.7073 6.70677C49.9811 6.03445 49.0353 5.6966 47.8732 5.6966C46.2914 5.6966 45.1681 6.30539 44.5032 7.5263ZM60.3782 12.3193V5.96054H57.983V12.3428C57.983 14.1089 58.4286 15.5004 59.3195 16.5106C60.2104 17.5241 61.3789 18.0292 62.8186 18.0292C64.552 18.0292 65.8787 17.387 66.7923 16.1025V18.1262C66.7923 19.2669 66.4824 20.1499 65.8626 20.7754C65.2429 21.401 64.494 21.7154 63.6094 21.7154C61.8889 21.7154 60.8754 20.9661 60.5654 19.4742H58.2187C58.3252 20.9326 58.8644 22.0532 59.8327 22.8326C60.8011 23.612 62.1214 24 63.6546 24C65.188 24 66.4727 23.5049 67.5121 22.5081C68.5515 21.5147 69.0712 20.0697 69.0712 18.1731V5.96054H66.6761V12.1521C66.6761 13.1623 66.3791 14.0153 65.7819 14.7043C65.188 15.3967 64.4681 15.7412 63.4933 15.7412C62.5184 15.7412 61.7566 15.4268 61.2047 14.8013C60.6526 14.1725 60.3782 13.3463 60.3782 12.3193ZM81.5989 5.93699L84.3427 15.2828L87.1768 5.93699H89.8496L85.8275 17.8819H83.0385L81.6892 13.9315L80.5724 9.79039L79.4328 13.9315L78.0836 17.8819H75.2945L71.2498 5.93699H73.9453L76.7795 15.2828L79.5232 5.93699H81.5924H81.5989ZM94.65 14.992C93.9754 14.4467 93.5848 13.7242 93.475 12.8244L93.4847 12.8278H102.781C102.998 10.4829 102.572 8.70006 101.503 7.47915C100.431 6.25824 98.9368 5.64945 97.0162 5.64945C95.2343 5.64945 93.785 6.22479 92.668 7.38216C91.5544 8.5395 90.9959 9.92767 90.9959 11.8377C90.9959 13.7476 91.5576 15.273 92.6809 16.4136C93.8043 17.5542 95.3021 18.1229 97.1775 18.1229C98.1073 18.1229 99.0175 17.9489 99.9084 17.5944C100.799 17.2431 101.529 16.7447 102.103 16.1025L100.544 14.5371C100.202 14.9217 99.7212 15.2328 99.0918 15.4636C98.4623 15.6944 97.8393 15.8115 97.2196 15.8115C96.1802 15.8115 95.3247 15.5372 94.65 14.992ZM99.4598 8.60977C100.07 9.10817 100.409 9.81395 100.47 10.7305H93.5202C93.7042 9.81395 94.1175 9.10817 94.763 8.60977C95.4086 8.11136 96.1802 7.86384 97.0774 7.86384C98.0524 7.86384 98.8465 8.11136 99.4598 8.60977ZM107.698 1V17.8352H105.303V1H107.698ZM113.53 17.8352V1H111.135V17.8352H113.53Z"
        }
      ) }
    )
  }
), mn = (l, o) => {
  let p;
  return (...d) => {
    p && clearTimeout(p), p = setTimeout(() => {
      l(...d);
    }, o);
  };
}, Ke = "nav-drawer-hover", Xe = "nav-drawer-animation-start", Je = "nav-drawer-animation-end", bt = (l) => {
  window.dispatchEvent(
    new CustomEvent(Ke, {
      detail: { isHovering: l },
      bubbles: !0,
      cancelable: !0
    })
  );
}, mt = (l) => {
  window.dispatchEvent(
    new CustomEvent(l, {
      bubbles: !0,
      cancelable: !0
    })
  );
}, wn = (l = !1, o = !1, p = !1) => l || !o ? "column" : p ? "row" : "row-reverse", yn = et(Gt), Cn = et(Ut), Ge = ({
  isOpen: l = !1,
  onClose: o,
  title: p,
  navDrawerLinks: d,
  bottomNavButtons: w,
  spotlightCards: v,
  bottomButton: b,
  hasBackButton: R = !0,
  onBackClick: c,
  hasOnlySpotlightCards: C = !1,
  hasSearch: u = !1,
  onSearch: y = () => ({}),
  topOffset: g
}) => {
  var q, Z;
  const s = Qe({
    base: !1,
    tablet: !1,
    largeTablet: !1,
    desktop: !0
  }), _ = s ? "top" : "right", [W, V] = B(0), [M, S] = B(!1), de = () => {
    V((L) => L + 1);
  }, fe = Ct(
    mn((L) => {
      y(L), de();
    }, 100),
    []
  );
  U(() => {
    l && (S(!0), mt(Xe));
  }, [l]);
  const pe = () => {
    l || (S(!1), o()), mt(Je);
  };
  return /* @__PURE__ */ t.jsx(
    Zt,
    {
      isOpen: M || l,
      onClose: () => {
        M && s || o();
      },
      placement: _,
      blockScrollOnMount: !1,
      autoFocus: !1,
      ...s ? {
        styleConfig: {
          baseStyle: {
            ...Ue.components.Drawer.baseStyle,
            dialogContainer: {
              ...(Z = (q = Ue.components.Drawer) == null ? void 0 : q.baseStyle) == null ? void 0 : Z.dialogContainer,
              // Push the drawer down by the top offset on desktop to not cover the top navigation
              top: s ? `${g}px` : void 0,
              // Lower index on desktop to make sure the drawer is below the top navigation
              zIndex: ["overlay"]
            }
          }
        }
      } : {},
      children: /* @__PURE__ */ t.jsx(
        pn,
        { children: l ? /* @__PURE__ */ t.jsxs(
          t.Fragment,
          { children: [
            /* @__PURE__ */ t.jsx(
              Cn,
              {
                backgroundColor: "tints.black",
                top: ["0", null, null, `${g}px`],
                opacity: s ? void 0 : "0.4 !important",
                ...s ? {
                  initial: { opacity: 0 },
                  animate: { opacity: 0.4 },
                  exit: { opacity: 0 },
                  transition: {
                    duration: 0.2,
                    delay: 0.15,
                    ease: "easeOut"
                  }
                } : {}
              }
            ),
            /* @__PURE__ */ t.jsxs(
              yn,
              {
                onClick: (L) => {
                  const A = L.target.closest("a");
                  A && A.href === window.location.href && o();
                },
                onMouseEnter: () => {
                  s && bt(!0);
                },
                onMouseLeave: () => {
                  s && bt(!1);
                },
                paddingTop: "4",
                paddingX: [4, null, null, 12],
                paddingBottom: "24",
                overflow: ["auto", null, null, "hidden"],
                maxHeight: "100vh",
                position: "relative",
                top: s ? `${g}px !important` : void 0,
                onAnimationComplete: pe,
                boxShadow: "none",
                ...s ? {
                  initial: { height: 0, opacity: 0 },
                  animate: { height: "auto", opacity: 1 },
                  exit: { height: 0, opacity: 0 },
                  transition: { duration: 0.3 }
                } : {},
                children: [
                  !u && s ? null : /* @__PURE__ */ t.jsxs(
                    Kt,
                    {
                      padding: "0",
                      flexDirection: u ? "column" : "row",
                      gap: u ? "4" : "0",
                      children: [
                        s ? null : /* @__PURE__ */ t.jsxs(
                          D,
                          {
                            width: "100%",
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                              R ? /* @__PURE__ */ t.jsx(
                                ce,
                                {
                                  icon: /* @__PURE__ */ t.jsx(sn, {}),
                                  onClick: () => {
                                    c && c();
                                  },
                                  "aria-label": "Back"
                                }
                              ) : null,
                              /* @__PURE__ */ t.jsx(
                                J,
                                {
                                  color: "tints.uiGrey",
                                  fontSize: ["xl", null, null, "lg"],
                                  children: p
                                }
                              ),
                              /* @__PURE__ */ t.jsx(
                                ce,
                                {
                                  icon: /* @__PURE__ */ t.jsx(un, {}),
                                  onClick: o,
                                  "aria-label": "Close"
                                }
                              )
                            ]
                          }
                        ),
                        u && /* @__PURE__ */ t.jsxs(
                          rn,
                          { width: "100%", children: [
                            /* @__PURE__ */ t.jsx(
                              ln,
                              {
                                onChange: (L) => {
                                  fe(L.target.value);
                                },
                                placeholder: "Search",
                                autoFocus: !0,
                                width: "full",
                                type: "search"
                              }
                            ),
                            /* @__PURE__ */ t.jsx(
                              an,
                              { pointerEvents: "none", children: /* @__PURE__ */ t.jsx(on, { as: jt, color: "gray.500" }) }
                            )
                          ] }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ t.jsx(
                    Xt,
                    {
                      paddingX: "0",
                      paddingBottom: [6, null, null, 4],
                      "data-testid": `navbar-drawer-body-${p.toLowerCase()}`,
                      children: /* @__PURE__ */ t.jsxs(
                        et.div,
                        {
                          ...s ? {
                            initial: { opacity: 0, y: -5 },
                            animate: { opacity: 1, y: 0 },
                            exit: { opacity: 0, y: -5 },
                            transition: {
                              duration: 0.5,
                              delay: 0.2,
                              ease: [0.4, 0, 0.2, 1],
                              exit: {
                                duration: 0.5,
                                delay: 0.2,
                                ease: [0.4, 0, 0.2, 1]
                              }
                            }
                          } : {},
                          style: {
                            display: "flex",
                            flexDirection: wn(
                              C,
                              s,
                              u
                            ),
                            gap: "24px",
                            justifyContent: "space-between"
                          },
                          children: [
                            v ? /* @__PURE__ */ t.jsx(
                              E,
                              {
                                gap: [3, null, null, 6],
                                display: "flex",
                                justifyContent: [null, null, null, "center"],
                                sx: {
                                  flexWrap: "wrap",
                                  flexDirection: ["column", null, null, "row"]
                                },
                                children: v
                              }
                            ) : null,
                            /* @__PURE__ */ t.jsxs(
                              D,
                              {
                                position: [null, null, null, "relative"],
                                flexDirection: "column",
                                gap: "6",
                                width: ["100%", null, null, u ? null : "auto"],
                                children: [
                                  d ? /* @__PURE__ */ t.jsx(E, { children: d }) : null,
                                  w && !s ? /* @__PURE__ */ t.jsx(E, { children: w }) : null,
                                  b ? /* @__PURE__ */ t.jsx(
                                    E,
                                    {
                                      width: ["100%"],
                                      position: [null, null, null, "absolute"],
                                      bottom: [null, null, null, 0],
                                      children: b
                                    }
                                  ) : null
                                ]
                              }
                            )
                          ]
                        },
                        W
                      )
                    }
                  )
                ]
              }
            )
          ] }
        ) : null }
      )
    }
  );
}, jn = ({
  desktopTopButtons: l,
  kitRegistrationElement: o,
  profileElement: p,
  cartElement: d,
  onSearchClick: w,
  onMenuClick: v,
  hasSearch: b = !1,
  logoLink: R = "https://www.everlywell.com",
  setTopOffset: c,
  linkComponent: C,
  onLogoClick: u
}) => {
  const y = en(null), [g, s] = B(!1);
  U(() => {
    const W = () => s(!0), V = () => s(!1);
    return window.addEventListener(Xe, W), window.addEventListener(Je, V), () => {
      window.removeEventListener(
        Xe,
        W
      ), window.removeEventListener(Je, V);
    };
  }, []);
  const _ = Ct(() => {
    if (y.current) {
      const W = y.current.getBoundingClientRect();
      c(W.bottom);
    }
  }, []);
  return U(() => {
    _();
  }, [_]), /* @__PURE__ */ t.jsx(
    E,
    {
      ref: y,
      paddingY: "4",
      paddingX: [4, null, null, 12],
      borderBottom: "1px solid",
      borderColor: "tints.lightCream",
      backgroundColor: "tints.white",
      position: "sticky",
      top: "0",
      width: "100%",
      zIndex: ["sticky", null, null, g ? "modal" : "sticky"],
      onMouseEnter: _,
      children: /* @__PURE__ */ t.jsxs(
        D,
        { justifyContent: "space-between", alignItems: "center", children: [
          /* @__PURE__ */ t.jsxs(
            D,
            { alignItems: "center", gap: "5", children: [
              /* @__PURE__ */ t.jsx(
                E,
                {
                  "aria-label": "Go to homepage",
                  onClick: u,
                  as: C || G,
                  ...Oe(R, !!C),
                  children: /* @__PURE__ */ t.jsx(bn, { width: "116px" })
                }
              ),
              /* @__PURE__ */ t.jsx(
                D,
                { display: ["none", null, null, "flex"], children: l }
              )
            ] }
          ),
          /* @__PURE__ */ t.jsxs(
            D,
            { alignItems: "center", gap: "2", children: [
              /* @__PURE__ */ t.jsx(
                E,
                { display: ["none", null, null, "block"], children: o }
              ),
              b ? /* @__PURE__ */ t.jsx(
                ce,
                {
                  "aria-label": "Search",
                  icon: /* @__PURE__ */ t.jsx(ue, { as: jt }),
                  onClick: w
                }
              ) : null,
              d,
              /* @__PURE__ */ t.jsx(
                E,
                { display: ["flex", null, null, "none"], children: /* @__PURE__ */ t.jsx(
                  ce,
                  {
                    icon: /* @__PURE__ */ t.jsx(cn, {}),
                    "aria-label": "menu",
                    "data-testid": "menu-button",
                    onClick: v
                  }
                ) }
              ),
              /* @__PURE__ */ t.jsx(E, { display: ["none", null, null, "block"], children: p })
            ] }
          )
        ] }
      )
    }
  );
}, En = ({
  count: l = 0,
  ...o
}) => /* @__PURE__ */ t.jsxs(
  E,
  { position: "relative", display: "inline-block", children: [
    /* @__PURE__ */ t.jsx(ce, { icon: /* @__PURE__ */ t.jsx(dn, {}), ...o }),
    l > 0 && /* @__PURE__ */ t.jsx(
      E,
      {
        display: "flex",
        minWidth: "20px",
        height: "20px",
        py: "4px",
        px: "6px",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        right: "-4px",
        top: "-4px",
        borderRadius: "32px",
        background: "viridian.base",
        color: "white",
        fontSize: "xs",
        fontWeight: "normal",
        children: l
      }
    )
  ] }
), Ln = ({
  numDesktopLinks: l = 5,
  showPromoButton: o = !1
}) => /* @__PURE__ */ t.jsx(
  Jt,
  { spacing: 0, align: "stretch", children: /* @__PURE__ */ t.jsx(
    E,
    {
      paddingY: 4,
      paddingX: 6,
      borderBottomWidth: "1px",
      borderColor: "tints.lightCream",
      children: /* @__PURE__ */ t.jsxs(
        D,
        { justify: "space-between", align: "center", children: [
          /* @__PURE__ */ t.jsx(Ve, { w: "120px", h: "48px" }),
          /* @__PURE__ */ t.jsxs(
            ft,
            {
              spacing: 8,
              marginLeft: 12,
              display: ["none", null, null, "flex"],
              "data-testid": "desktop-nav",
              children: [
                Array.from({ length: l }).map(
                  (p, d) => /* @__PURE__ */ t.jsx(Ve, { width: "90px", height: "48px" }, d)
                ),
                o && /* @__PURE__ */ t.jsx(Ve, { width: "110px", height: "48px", borderRadius: "full" })
              ]
            }
          ),
          /* @__PURE__ */ t.jsxs(
            ft,
            { spacing: 4, ml: "auto", children: [
              /* @__PURE__ */ t.jsx(
                De,
                {
                  width: "120px",
                  height: "48px",
                  display: ["none", null, null, "block"],
                  "data-testid": "register-kit"
                }
              ),
              " ",
              /* @__PURE__ */ t.jsx(De, { width: "48px", height: "48px" }),
              " ",
              /* @__PURE__ */ t.jsx(De, { width: "48px", height: "48px" }),
              " ",
              /* @__PURE__ */ t.jsx(De, { width: "48px", height: "48px" }),
              " "
            ] }
          )
        ] }
      )
    }
  ) }
), Rn = ({
  source: l,
  onSearchCallback: o,
  isActive: p
}) => {
  const [d, w] = B(""), [v, b] = B([]), R = (u, y) => {
    if (!u) return [];
    const g = u.toLowerCase();
    return y.filter((s) => {
      const _ = s.label.toLowerCase().includes(g), W = typeof s.additionalContent == "string" && s.additionalContent.toLowerCase().includes(g);
      return _ || W;
    }).sort((s, _) => s.label.localeCompare(_.label));
  }, c = (u) => {
    if (w(u), !u) {
      b([]);
      return;
    }
    const y = R(u, l);
    b(y), o && o(u, y);
  }, C = () => {
    w(""), b([]);
  };
  return U(() => {
    p || (w(""), b([]));
  }, [p]), {
    query: d,
    results: v,
    handleClose: C,
    handleSearch: c
  };
}, _n = (l) => {
  const o = /* @__PURE__ */ new Set();
  return l.reduce((p, d) => {
    var v;
    const w = ((v = d.sections) == null ? void 0 : v.reduce((b, R) => {
      const c = R.links.filter((C) => o.has(C.label) || C.isSearchable !== !0 ? !1 : (o.add(C.label), !0));
      return [...b, ...c];
    }, [])) ?? [];
    return [...p, ...w];
  }, []);
}, An = ({
  categories: l = [],
  onCartClick: o,
  mainCategoryLabel: p = "Menu",
  logoLink: d = "https://www.everlywell.com",
  hasSearch: w = !0,
  onSearchClick: v,
  registrationUrl: b,
  profileUrl: R = "https://secure.everlywell.com/login",
  mobileBottomButtons: c = [],
  numberOfCartItems: C = 0,
  linkComponent: u,
  onSearchCallback: y,
  onLinkClick: g,
  onCategoryOpen: s,
  onMobileMenuOpen: _,
  onBackToMainMenu: W,
  onRegisterKitClick: V,
  onProfileClick: M,
  onLogoClick: S,
  shopAllProductsUrl: de,
  onShopAllProductsClick: fe
}) => {
  var K, be, me;
  const [pe, q] = B(!1), [Z, L] = B(!1), [j, A] = B(null), [je, he] = B(!1), [$, Y] = B(!1), [z, Ee] = B(0), Re = Qe({
    base: !1,
    tablet: !1,
    largeTablet: !1,
    desktop: !0
  }) ?? !1;
  U(() => {
    re(), A(null);
  }, [Re]);
  const {
    query: _e,
    results: te,
    handleSearch: Se
  } = Rn({
    source: _n(l),
    onSearchCallback: y,
    isActive: Z
  }), ve = te.length > 0, ne = u || G, Te = Oe(de, !!u), Pe = _e && /* @__PURE__ */ t.jsxs(
    D,
    { gap: ve ? "6" : 0, direction: "column", children: [
      ve ? /* @__PURE__ */ t.jsx(J, { color: "tints.uiGrey", children: `${te.length} Results` }) : /* @__PURE__ */ t.jsxs(
        D,
        { direction: "column", gap: "6", alignItems: "flex-start", children: [
          /* @__PURE__ */ t.jsx(
            J,
            { color: "tints.uiGrey", children: "We didn't find what you were looking for." }
          ),
          /* @__PURE__ */ t.jsx(
            wt,
            {
              as: ne,
              onClick: fe,
              _hover: { textDecoration: "none" },
              width: ["100%", null, null, "auto"],
              ...Te,
              children: "Shop all products"
            }
          )
        ] }
      ),
      /* @__PURE__ */ t.jsx(
        qt,
        { columns: [1, 1, 1, 4], children: te.map(
          (a, I) => /* @__PURE__ */ t.jsx(
            Qt,
            { children: /* @__PURE__ */ t.jsx(
              ze,
              {
                href: a.href,
                label: a.label,
                additionalContent: a == null ? void 0 : a.additionalContent,
                linkComponent: u
              }
            ) },
            `${a.label}-${I}`
          )
        ) }
      )
    ] }
  ), re = () => {
    q(!1), A(null);
  }, N = (a) => "href" in a, ge = (a) => {
    N(a) ? g == null || g(a.label) : A(a);
  }, le = (a) => {
    he(!0), L(!1), A(null), !N(a) && (a.sections || a.spotlightCards) && A(a);
  }, xe = () => {
    he(!1);
  };
  U(() => {
    const a = (I) => {
      Y(I.detail.isHovering);
    };
    return window.addEventListener(
      Ke,
      a
    ), () => {
      window.removeEventListener(
        Ke,
        a
      );
    };
  }, []), U(() => {
    !je && !$ && (A(null), L(!1));
  }, [je, $]), U(() => {
    let a = window.location.href;
    const I = () => {
      const O = window.location.href;
      O !== a && (a = O, re(), A(null));
    }, X = setInterval(I, 100);
    return window.addEventListener("popstate", I), () => {
      window.removeEventListener("popstate", I), clearInterval(X);
    };
  }, []);
  const ae = l == null ? void 0 : l.map(
    (a, I) => /* @__PURE__ */ t.jsx(
      Ie,
      {
        onMouseEnter: () => {
          le(a), s == null || s(a.label);
        },
        onMouseLeave: xe,
        isSelected: (j == null ? void 0 : j.label) === a.label,
        as: N(a) && ne ? ne : G,
        href: N(a) ? a.href : void 0,
        onClick: N(a) ? () => g == null ? void 0 : g(a.label) : void 0,
        ...a.buttonProps,
        children: a.label
      },
      `${a.label}-${I}`
    )
  ), Le = (K = l.filter(
    (a) => !N(a) && a.isMobileTopLink !== !1
  )) == null ? void 0 : K.map((a) => {
    const I = a;
    return /* @__PURE__ */ t.jsx(
      E,
      {
        onClick: () => {
          ge(I), s == null || s(I.label);
        },
        children: /* @__PURE__ */ t.jsx(
          ze,
          {
            label: I.label,
            role: "link",
            additionalContent: I.additionalContent,
            mainTextFontSize: "3xl",
            linkComponent: u
          }
        )
      },
      I.label
    );
  }), ke = /* @__PURE__ */ t.jsxs(
    t.Fragment,
    { children: [
      /* @__PURE__ */ t.jsx(
        Ie,
        {
          as: G,
          href: R,
          width: "100%",
          backgroundColor: "tints.cream",
          onClick: M,
          children: /* @__PURE__ */ t.jsxs(
            D,
            { gap: "2", children: [
              "My Everly",
              /* @__PURE__ */ t.jsx(ue, { as: ht, size: 24 })
            ] }
          )
        },
        "my-everly"
      ),
      /* @__PURE__ */ t.jsx(
        Ie,
        {
          as: G,
          width: "100%",
          href: b,
          backgroundColor: "tints.cream",
          onClick: V,
          children: /* @__PURE__ */ t.jsxs(
            D,
            { gap: "2", children: [
              "Register kit",
              /* @__PURE__ */ t.jsx(ue, { as: fn, size: 24 })
            ] }
          )
        },
        "register-kit"
      )
    ] }
  ), Ae = /* @__PURE__ */ t.jsxs(
    D,
    { gap: "2", flexDirection: "column", children: [
      c,
      ke
    ] }
  ), He = j ? /* @__PURE__ */ t.jsx(
    D,
    { direction: ["column", null, null, "row"], gap: "8", children: (be = j == null ? void 0 : j.sections) == null ? void 0 : be.map((a, I) => {
      const X = [];
      for (let O = 0; O < a.links.length; O += 3)
        X.push(a.links.slice(O, O + 3));
      return /* @__PURE__ */ t.jsxs(
        E,
        { children: [
          /* @__PURE__ */ t.jsx(
            J,
            {
              fontSize: "md",
              color: "tints.uiGrey",
              marginBottom: [0, null, null, 6],
              children: a.title
            }
          ),
          /* @__PURE__ */ t.jsx(
            D,
            {
              flexDirection: ["column", null, null, "row"],
              gap: [null, null, null, 8],
              children: X == null ? void 0 : X.map(
                (O, $e) => /* @__PURE__ */ t.jsx(
                  D,
                  {
                    flexDirection: ["column"],
                    gap: [null, null, null, 5],
                    marginLeft: [null, null, null, -2],
                    children: O == null ? void 0 : O.map(
                      (Q) => /* @__PURE__ */ t.jsx(
                        ze,
                        {
                          label: Q.label,
                          href: Q.href,
                          additionalContent: Q.additionalContent,
                          linkComponent: u,
                          onClick: () => g == null ? void 0 : g(Q.label)
                        },
                        Q.label
                      )
                    )
                  },
                  $e
                )
              )
            }
          )
        ] },
        `${a.title}-${I}`
      );
    }) }
  ) : null, ie = j != null && j.spotlightCards ? (me = j.spotlightCards) == null ? void 0 : me.map(
    (a) => /* @__PURE__ */ t.jsx(xn, { ...a }, a.title)
  ) : /* @__PURE__ */ t.jsx(E, {});
  return /* @__PURE__ */ t.jsxs(
    t.Fragment,
    { children: [
      /* @__PURE__ */ t.jsx(
        jn,
        {
          desktopTopButtons: ae,
          kitRegistrationElement: /* @__PURE__ */ t.jsx(
            Ie,
            {
              as: G,
              href: b,
              onClick: V,
              backgroundColor: "tints.cream",
              children: "Register Kit"
            }
          ),
          profileElement: /* @__PURE__ */ t.jsx(
            G,
            { href: R, "aria-label": "login", onClick: M, children: /* @__PURE__ */ t.jsx(ce, { icon: /* @__PURE__ */ t.jsx(ue, { as: ht }), "aria-label": "Profile" }) }
          ),
          cartElement: /* @__PURE__ */ t.jsx(
            En,
            {
              "aria-label": "Cart",
              count: C,
              onClick: o
            }
          ),
          onSearchClick: () => {
            L(!Z), v == null || v();
          },
          onMenuClick: () => {
            q(!0), _ == null || _();
          },
          hasSearch: w,
          logoLink: d,
          linkComponent: u,
          onLogoClick: S,
          setTopOffset: Ee
        }
      ),
      /* @__PURE__ */ t.jsxs(
        E,
        { position: "relative", zIndex: "modal", children: [
          /* @__PURE__ */ t.jsx(
            Ge,
            {
              isOpen: pe,
              onClose: re,
              title: p,
              navDrawerLinks: Le,
              bottomNavButtons: Ae,
              hasBackButton: !1,
              topOffset: z
            }
          ),
          /* @__PURE__ */ t.jsx(
            Ge,
            {
              isOpen: !!j,
              onClose: () => {
                re(), A(null);
              },
              title: (j == null ? void 0 : j.label) || "",
              navDrawerLinks: He,
              onBackClick: () => A(null),
              spotlightCards: ie,
              hasOnlySpotlightCards: j == null ? void 0 : j.hasOnlySpotlightCards,
              bottomButton: j == null ? void 0 : j.bottomButton,
              topOffset: z
            }
          ),
          /* @__PURE__ */ t.jsx(
            Ge,
            {
              isOpen: Z,
              onClose: () => L(!1),
              title: "Search",
              navDrawerLinks: Pe,
              onSearch: Se,
              hasSearch: !0,
              hasBackButton: !1,
              topOffset: z
            }
          )
        ] }
      )
    ] }
  );
};
export {
  En as BasketButton,
  Pn as CategoryLabel,
  Ie as NavButton,
  Ln as NavSkeleton,
  Ge as NavbarDrawer,
  ze as NavbarDrawerLink,
  An as NavigationBar,
  xn as SpotlightCard,
  On as Stepper,
  ce as TopNavIconButton,
  jn as TopNavigation
};
